import React, { useEffect } from "react";
import { BiMinus, BiPlus, BiX } from "react-icons/bi";
import { useDispatch } from "react-redux";
import Logo from "../../Assets/Logo";
import Gap from "../../components/Gap";
import { imageBaseUrl } from "../../Constants";
import { setKeranjang } from "../../redux/actions/prepareActions";
import { decrypt, encrypt } from "../../utils/enkripsi";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log";
import "./ModalBayar.css";

export default function ModalBayar({
  showBayar,
  setShowBayar,
  onClickTambahPesanan,
  dataOrder,
}) {
  const dispatch = useDispatch();
  const [isPlusClicked, setIsPlusClicked] = React.useState(false);
  const [isMinusClicked, setIsMinusClicked] = React.useState(false);
  const [quantity, setQuantity] = React.useState(1);
  const [quantity2, setQuantity2] = React.useState(0);
  const [note, setNote] = React.useState("");
  let pesanan = localStorage.getItem("pesanan");
  pesanan = pesanan == null ? [] : decrypt(JSON.parse(pesanan));
  const [showImage, setShowImage] = React.useState(false);

  useEffect(() => {
    showLog("ModalBayar Masuk useEffect 1");
    if (showBayar) {
      let pesanan1 = decrypt(JSON.parse(localStorage.getItem("pesanan")));
      setNote("");
      if (pesanan1) {
        if (pesanan1.length !== 0) {
          let number = 1;
          let price = 0;
          for (const x of pesanan1) {
            if (dataOrder["product_id"] == x["product_id"]) {
              number = x["item"];
              price = x["item"];
              setNote(x["note"]);
            }
          }
          setQuantity(number);
          setQuantity2(price);
        }
      }
    }
  }, [showBayar]);

  useEffect(() => {
    function imageExists(url, callback) {
      var img = new Image();
      img.onload = function () {
        callback(true);
      };
      img.onerror = function () {
        callback(false);
      };
      img.src = url;
    }

    if (dataOrder["picpath1"] && dataOrder["picpath1"] !== "-") {
      const imageUrl = imageBaseUrl + dataOrder["picpath1"];
      imageExists(imageUrl, function (exists) {
        setShowImage(exists);
      });
    } else {
      setShowImage(false);
    }
  }, [dataOrder["picpath1"], imageBaseUrl]);

  const updatePesananState = (updatedList) => {
    const filtered = updatedList.filter((item) => item.item > 0);
    localStorage.setItem("pesanan", JSON.stringify(encrypt(filtered)));
    dispatch(setKeranjang(filtered));
  };

  return (
    <div className={showBayar ? "modal-menu active" : "modal-menu"}>
      <div
        onClick={() => {
          setShowBayar(false);
          dataOrder["show_img"] = true;
        }}
        style={{
          margin: "10px 0px 0 10px",
          position: "fixed",
          borderRadius: 40,
          height: 40,
          width: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          cursor: "pointer",
        }}
      >
        <BiX size={30} color="#fff" />
      </div>
      {showImage ? (
        <img
          style={{
            height: "auto",
            width: "100%",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            marginBottom: 10,
          }}
          src={imageBaseUrl + dataOrder["picpath1"]}
          onError={(e) => {
            e.target.onerror = null;
            setShowImage(false);
          }}
        />
      ) : (
        <div
          style={{
            width: "100%",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            marginBottom: 10,
            height: "50%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Logo height="50" width="200" />
        </div>
      )}
      <div style={{ width: "100%" }}>
        <div style={{ margin: 20 }}>
          <div className="fonts700" style={{ fontSize: 16, paddingTop: 5 }}>
            {(dataOrder["product_name"] || dataOrder["name"] || "")
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")}
          </div>
          <span
            className="fonts700"
            style={{ fontSize: 16, marginRight: 10, paddingTop: 5 }}
          >
            {"Rp" + formatterMoney(dataOrder["usePrice"])}
          </span>
          <div style={{ paddingTop: 5 }}>
            <span style={{ fontWeight: "700", fontSize: 15 }}>
              Detail Produk
            </span>
            <Gap height={5} />
            <div
              className="fonts400"
              style={{ fontSize: 14, color: "#7E7E7E", textAlign: "justify" }}
            >
              {dataOrder["description_menu"] == ""
                ? "-"
                : dataOrder["description_menu"]}
            </div>
          </div>
          <div>
            <textarea
              value={note}
              onChange={(val) => setNote(val.target.value)}
              style={{
                height: "90px",
                marginTop: "20px",
                marginBottom: "20px",
                border: "1px solid #BFBFBF",
                borderRadius: 5,
              }}
              placeholder=" Order note..."
            />
          </div>

          <div style={{ display: "flex", paddingTop: 20 }}>
            <div
              style={{
                display: "flex",
                width: "40%",
                backgroundColor: "#fff",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => {
                  setQuantity((val) => (val > 1 ? val - 1 : val));
                  setIsMinusClicked(true);
                  setTimeout(() => setIsMinusClicked(false), 200);
                }}
                style={{
                  border:
                    "1px solid " + (quantity !== 1 ? "#5451D6" : "#BFBFBF"),
                  height: 40,
                  width: 40,
                  borderRadius: 10,
                  backgroundColor: isMinusClicked ? "#5451D6" : "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "background-color 0.2s ease-in-out",
                }}
              >
                <BiMinus
                  size={20}
                  color={
                    isMinusClicked
                      ? "#fff"
                      : quantity !== 1
                      ? "#5451D6"
                      : "#BFBFBF"
                  }
                />
              </button>
              <span className="fonts700" style={{ fontSize: 20 }}>
                {" "}
                {quantity != 0 ? quantity : 1}{" "}
              </span>
              <button
                onClick={() => {
                  setQuantity((val) => val + 1);
                  setIsPlusClicked(true);
                  setTimeout(() => setIsPlusClicked(false), 200);
                }}
                style={{
                  border: "1px solid #5451D6",
                  height: 40,
                  width: 40,
                  borderRadius: 10,
                  backgroundColor: isPlusClicked ? "#5451D6" : "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "background-color 0.2s ease-in-out",
                }}
              >
                <BiPlus size={20} color={isPlusClicked ? "#fff" : "#5451D6"} />
              </button>
            </div>
            <div
              style={{
                width: "60%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => {
                  const updatedPesanan = JSON.parse(JSON.stringify(pesanan));
                  const existingItemIndex = updatedPesanan.findIndex(
                    (item) => item.product_id === dataOrder.product_id
                  );
                  if (existingItemIndex !== -1) {
                    updatedPesanan[existingItemIndex].item = quantity;
                    updatedPesanan[existingItemIndex].total =
                      dataOrder.usePrice * quantity;
                  } else {
                    updatedPesanan.push({
                      ...dataOrder,
                      item: quantity,
                      total: dataOrder.usePrice * quantity,
                      note: note,
                    });
                  }
                  updatePesananState(updatedPesanan);
                  setShowBayar(false);
                  if (quantity != quantity2) {
                    const changeType =
                      quantity > quantity2 ? "increase" : "decrease";
                    onClickTambahPesanan(changeType);
                  }
                }}
                style={{
                  padding: "7px 0 7px 0",
                  borderRadius: 5,
                  backgroundColor: "#552CB7",
                  width: "80%",
                  marginRight: 10,
                  display: "flex",
                  justifyContent: "space-around",
                  border: "none",
                  alignItems: "center",
                }}
              >
                <div style={{ color: "#fff" }} className="fonts500">
                  Tambah Pesanan
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
